import { cx } from "@suse-o11y/class-variance";
import { IconMuted } from "@suse-o11y/icons";
import React, { type FC } from "react";

import { HealthStateValue } from "~/models/dto";

import { healthStateToBackgroundColorToken } from "../../../common/functions";
import type { Api } from "../../../common/openapi";
import { type IconSize, getSizeForIcon } from "../icon/IconSizes";

export interface StateIconProps {
	iconNode?: React.ReactNode;
	iconSize?: IconSize;
	icon?: string;
	disabled?: boolean;
	healthStateValue?: HealthStateValue | Api.HealthStateValue;
	displayType?: "component" | "group";
	muted?: boolean;
}

export const StateIcon: FC<StateIconProps> = ({
	iconNode,
	icon,
	iconSize = "default",
	disabled,
	healthStateValue = HealthStateValue.Unknown,
	displayType = "component",
	muted,
}) => {
	const componentStyle = () => {
		const size = getSizeForIcon(iconSize);
		const style = {
			width: size,
			height: size,
		};

		if (disabled) {
			return style;
		}

		return {
			...style,
			backgroundColor: `var(${healthStateToBackgroundColorToken(healthStateValue)})`,
		};
	};

	const stateIcon = icon ? <img alt="icon" className="block size-1/2" src={icon} /> : iconNode;

	return (
		<div
			className={cx(
				"grid-stack grid shrink-0 place-items-center items-center overflow-hidden rounded-sm",
				displayType === "component" ? "rounded-sm" : "rounded-full",
			)}
			data-testid="state-icon"
			style={componentStyle()}
		>
			{stateIcon}

			{muted && <span className="size-full origin-bottom-left rotate-45 scale-150 bg-core-fill-neutral-primary/95" />}
			{muted && <IconMuted className="translate-1/2 h-3.5 w-auto text-core-icon-neutral-tertiary" />}
		</div>
	);
};
